import React from "react";
import { useAppSelector } from "../../../redux/hooks";
import { Container } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { AvanzadoFrigorificoComponent } from "../../../components/Avanzados/AvanzadoFrigorificos";
import { ItemPlanta } from "../../../components/Avanzados/interfaces/avanzado.interface";

export const AvanzadoFrigorificoPage: React.FC = () => {
    const navigate = useNavigate();

    const PlantaData = useLocation();
    
    // const frioId: string = CamaraData.state.frioId;
    const planta: ItemPlanta = PlantaData.state.planta;

    const {userData } = useAppSelector((state) => state.authReducer)


    //Si no es administrador no permite ingresar
    React.useEffect(() => {
        if(userData?.role !== "ADMIN")
            {
                navigate('/');
            }
    },[userData, navigate])

    return (
        <Container 
            maxWidth={false} 
            sx={{
                px: 2, // padding horizontal: 2*8px = 16px
            }}
        > 
         {/*   <HeaderComponent 
                title="Control Avanzado"
                description= ""
                //element={<Button fullWidth variant="contained" onClick ={()=> navigate("/")} >Ir a Lista de Frigorificos</Button>}
            />*/}
            <AvanzadoFrigorificoComponent propsPlanta={planta}/>

        </Container>
    )

}